module.exports = __webpack_public_path__ + "static/media/heart-svgrepo-com (6).54ae9486.svg";